/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useEffect, useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import Select from 'react-select'
import {
  getObstacleHauterList,
  getObstacleSolList,
  getServiceT007,
  putServiceT007,
} from '../../core/prestation/request'
import {toast} from 'react-toastify'
import {useAuth} from '../../../../auth'
import {useSelector} from 'react-redux'
import {useParams} from 'react-router-dom'
import {useThemeMode} from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import {ListeServiceStatus, PutT007} from '../../core/prestation/model'
import {Button, Modal} from 'react-bootstrap'
import * as lodash from 'lodash'
import {CenterHelp} from '../../../../../common/components/CenterHelp/CenterHelp'

const initialTBForm7Values = {
  ObstaclesOnTheGround: '',
  ObstaclesOnTheGroundOther: '',
  ObstaclesAtHeight: '',
  ObstaclesAtHeightOther: '',
  //DescriptionOfObstaclesDimensions: '',
  //ServingsWidth: '',
  //ServingsHeight: '',
  DistanceBetweenServingsAndFacadeAngle: '',
}

type ToggleButtonform7Props = {
  isVisible6: boolean
  onDetectChange7?: (isThereChange: boolean) => void
  listeService?: any
  setListService?: any
  itemProps?: any
  setServiceData?: any
  onSavedForm?: (saved: boolean) => void
  loadListServiceStatus?: Function
  t007?: ListeServiceStatus
}
const ToggleButtonform7: FC<ToggleButtonform7Props> = ({
  isVisible6,
  onDetectChange7,
  listeService,
  setListService,
  itemProps,
  setServiceData,
  onSavedForm,
  loadListServiceStatus,
  t007,
}) => {
  const {mode, modeSelect} = useThemeMode()
  const intl = useIntl()
  const [serviceT007, setServiceT007] = useState<any>(null)
  const [t1init, setT1init] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const {setAuthMessage, logout} = useAuth()
  const projectData = useSelector((state: any) => state.projectData)
  const Submitted = useSelector((state: any) => state?.projectStatus?.Submitted)
  const {pGuid} = useParams()
  const [obstacleSolSelect, setObstacleSolSelect] = useState<any>(null)
  const [obstacleSolOption, setObstacleSolOption] = useState<any>(null)
  const [obstacleHauterSelect, setObstacleHauterSelect] = useState<any>(null)
  const [obstacleHauterOption, setObstacleHauterOption] = useState<any>(null)
  const [inputChange, setInputChange] = useState<any>(false)
  const [showCancel, setShowCancel] = useState<boolean>(false)

  const onAccessLost = (message: string) => {
    setAuthMessage(message)
    logout()
  }

  const loadServiceT007 = async () => {
    const response = await getServiceT007(
      pGuid || projectData?.tab1?.data?.Guid || '',
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )
    if (response?.data && response?.data?.data) {
      setServiceT007(response?.data?.data)
      setT1init(response?.data?.data)
    }
    setLoading(false)
  }
  useEffect(() => {
    loadServiceT007()
  }, [])

  useEffect(() => {
    const load = () => {
      loadObstacleSolList()
      loadObstacleHauterList()
    }
    if (t1init != null) {
      load()
    }
  }, [t1init])

  const handleObstacleSolChange = (sol: any) => {
    if (sol) {
      setObstacleSolSelect(sol)
      setServiceT007({
        ...serviceT007,
        ObstaclesOnTheGround: sol?.value,
        ObstaclesOnTheGroundOther: '',
      })
    } else {
      setObstacleSolSelect(null)
      setServiceT007({
        ...serviceT007,
        ObstaclesOnTheGround: null,
      })
    }
  }
  const handleObstacleHauteurtChange = (hauteur: any) => {
    if (hauteur) {
      setObstacleHauterSelect(hauteur)
      setServiceT007({
        ...serviceT007,
        ObstaclesAtHeight: hauteur.value,
        ObstaclesAtHeightOther: '',
      })
    } else {
      setObstacleHauterSelect(null)
      setServiceT007({
        ...serviceT007,
        ObstaclesAtHeight: null,
      })
    }
  }

  const handleClickT007 = async () => {
    try {
      if (serviceT007) {
        const dataToUpdate: PutT007 = {
          ProjectGuid: pGuid || projectData?.tab1?.data?.Guid || '',
          ObstaclesOnTheGround: serviceT007?.ObstaclesOnTheGround,
          ObstaclesOnTheGroundOther: serviceT007?.ObstaclesOnTheGroundOther || '',
          ObstaclesAtHeight: serviceT007?.ObstaclesAtHeight,
          ObstaclesAtHeightOther: serviceT007?.ObstaclesAtHeightOther || '',
          //DescriptionOfObstaclesDimensions: serviceT007?.DescriptionOfObstaclesDimensions || '',
          //ServingsWidth: serviceT007?.ServingsWidth || '',
          //ServingsHeight: serviceT007?.ServingsHeight || '',
          DistanceBetweenServingsAndFacadeAngle: serviceT007?.DistanceBetweenServingsAndFacadeAngle,
        }
        const response = await putServiceT007(dataToUpdate)
        if (response?.data?.Status?.Success) {
          if (onSavedForm) {
            onSavedForm(true)
          }
        }
        loadServiceT007()
        // onRefreshListeService7()
        if (loadListServiceStatus) await loadListServiceStatus()
      } else {
        console.log("serviceT006 n'est pas encore prêt.")
      }
    } catch (error) {
      console.error("Erreur lors de l'enregistrement des données :", error)
      toast.error("Une erreur s'est produite lors de l'enregistrement des données")
    }
  }
  const loadObstacleSolList = async () => {
    const Guid: string = pGuid || projectData?.tab1?.data?.Guid
    setLoading(true)
    let wsObjRes: any = null
    if (Guid) {
      wsObjRes = await getObstacleSolList(
        //{Guid: Guid},
        (message: string) => {
          setAuthMessage(message)
          logout()
        },
        ({Message, MessageType, Toast, ToastType}) => {
          if (Message && MessageType === 'Success') {
            //
          } else if (Message && MessageType === 'Error') {
            //
          } else if (Toast && ToastType === 'Success') {
            toast(Toast, {type: 'success'})
          } else if (Toast && ToastType === 'Error') {
            toast(Toast, {type: 'error'})
          }
        }
      )
      if (wsObjRes?.data?.Status?.FailureReason === 'Session expired') {
        onAccessLost(wsObjRes?.data?.Status?.Message)
        return
      }
      if (wsObjRes && wsObjRes?.data?.data) {
        const _obstacleSolOptions: any[] = (wsObjRes?.data?.data || []).map((obstacleSol: any) => ({
          ...obstacleSol,
          value: obstacleSol?.Guid,
          label: obstacleSol?.Name,
        }))
        setObstacleSolOption(_obstacleSolOptions)
        const obstacleSolSelected = _obstacleSolOptions.find(
          (option: any) => option?.Guid === serviceT007?.ObstaclesOnTheGround
        )
        if (obstacleSolSelected) {
          setObstacleSolSelect(obstacleSolSelected)
        } else {
          setObstacleHauterSelect(null)
        }
      }
    }
    setLoading(false)
  }

  const loadObstacleHauterList = async () => {
    const Guid: string = pGuid || projectData?.tab1?.data?.Guid
    setLoading(true)
    let wsObjRes: any = null
    if (Guid) {
      wsObjRes = await getObstacleHauterList(
        //{Guid: Guid},
        (message: string) => {
          setAuthMessage(message)
          logout()
        },
        ({Message, MessageType, Toast, ToastType}) => {
          if (Message && MessageType === 'Success') {
            //
          } else if (Message && MessageType === 'Error') {
            //
          } else if (Toast && ToastType === 'Success') {
            toast(Toast, {type: 'success'})
          } else if (Toast && ToastType === 'Error') {
            toast(Toast, {type: 'error'})
          }
        }
      )
      if (wsObjRes?.data?.Status?.FailureReason === 'Session expired') {
        onAccessLost(wsObjRes?.data?.Status?.Message)
        return
      }
      if (wsObjRes && wsObjRes?.data?.data) {
        const _obstacleheightOptions: any[] = (wsObjRes?.data?.data || []).map((ns: any) => ({
          ...ns,
          value: ns?.Guid,
          label: ns?.Name,
        }))

        setObstacleHauterOption(_obstacleheightOptions)
        const obstacleHauteurSelected = _obstacleheightOptions.find(
          (option: any) => option?.Guid === serviceT007?.ObstaclesAtHeight
        )
        if (obstacleHauteurSelected) {
          setObstacleHauterSelect(obstacleHauteurSelected)
        } else {
          setObstacleHauterSelect(null)
        }
      }
    }
    setLoading(false)
  }

  const isDisabled = useMemo(() => {
    return lodash.isEqual(serviceT007, t1init)
  }, [serviceT007, t1init])

  const onCancelReset = () => {
    setShowCancel(false)
  }
  const onConfirmCancel = async () => {
    await handleObstacleHauteurtChange(null)
    await handleObstacleSolChange(null)
    await setServiceT007(null)
    await setT1init(null)
    await setObstacleSolSelect(null)
    await handleObstacleSolChange(null)
    await loadServiceT007()
    setShowCancel(false)
    //}
  }

  useEffect(() => {
    if (onDetectChange7) {
      onDetectChange7(isDisabled)
    }
  }, [isDisabled, onDetectChange7])
  return (
    <div>
      {isVisible6 && (
        <div className='d-flex flex-column'>
          <form>
            <div className='p-5 mt-8'>
              <div className='d-flex justify-content-between mb-5'>
                <div
                  style={{flex: 10}}
                  className='gap-1 justify-content-xl-between d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row flex-1'
                >
                  <div style={{flex: 0.5}} className='mb-5 mb-sm-5 mb-md-5 mb-lg-5'>
                    <div className='fs-4 text-gray-700 me-2 '>
                      {intl.formatMessage({id: 'PRESENCE_OF_GROUND_OBSTACLES'})}
                    </div>
                  </div>
                  <div style={{flex: 0.5}}>
                    <div>
                      <Select
                        className='form-select-solid custom-select mb-3'
                        value={obstacleSolSelect}
                        onChange={handleObstacleSolChange}
                        options={obstacleSolOption}
                        styles={modeSelect}
                        isDisabled={Submitted}
                      />
                    </div>
                    <div className='d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row'>
                      <label className='fs-6 text-gray-700 me-2'>
                        {intl.formatMessage({id: 'OTHER'})}
                      </label>
                      <input
                        type='text'
                        className='form-control form-control-solid'
                        value={serviceT007?.ObstaclesOnTheGroundOther ?? ''}
                        disabled={Submitted}
                        onChange={(e) => {
                          setServiceT007({
                            ...serviceT007,
                            ObstaclesOnTheGround: null,
                            ObstaclesOnTheGroundOther: e.target?.value ?? '',
                          })
                          setObstacleSolSelect(null)
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className='justify-content-end'>{/*<CenterHelp />*/}</div>
              </div>

              <div
                style={{flex: 10}}
                className='gap-1 justify-content-xl-between d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row flex-1'
              >
                <div style={{flex: 0.5}} className='mb-5 mb-sm-5 mb-md-5 mb-lg-5'>
                  <div className='fs-4 text-gray-700 mb-2'>
                    {intl.formatMessage({id: 'PRESENCE_OF_OBSTACLES_AT_HEIGHT'})}
                  </div>
                  <div className='fs-5 text-gray-700 fw-bold'>
                    {intl.formatMessage({id: 'MESSAGE_HEIGHT'})}
                  </div>
                </div>
                <div style={{flex: 0.5}} className='pe-14'>
                  <div>
                    <Select
                      className='form-select-solid custom-select mb-3'
                      value={obstacleHauterSelect}
                      onChange={handleObstacleHauteurtChange}
                      options={obstacleHauterOption}
                      styles={modeSelect}
                      isDisabled={Submitted}
                    />
                  </div>
                  <div className='d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row'>
                    <label className='fs-6 text-gray-700 me-2'>
                      {intl.formatMessage({id: 'OTHER'})}
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-solid'
                      value={serviceT007?.ObstaclesAtHeightOther ?? ''}
                      onChange={(e) => {
                        setServiceT007({
                          ...serviceT007,
                          ObstaclesAtHeight: null,
                          ObstaclesAtHeightOther: e.target?.value ?? '',
                        })
                        setObstacleHauterSelect(null)
                      }}
                      disabled={Submitted}
                    />
                  </div>
                </div>
              </div>
              {/*}
              <div
                style={{flex: 10}}
                className='gap-1 justify-content-xl-between d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row flex-1 my-5'
              >
                <div style={{flex: 0.5}} className='mb-5 mb-sm-5 mb-md-5 mb-lg-5'>
                  <label className='fs-4 text-gray-700 me-2 '>
                    {intl.formatMessage({id: 'DESCRIBE_THE_DIMENSIONS_OF_THE_OBSTACLES'})}
                  </label>
                </div>
                <div style={{flex: 0.5}} className='pe-14'>
                  <input
                    type='text'
                    className='form-control form-control-solid'
                    value={serviceT007?.DescriptionOfObstaclesDimensions ?? ''}
                    onChange={(e) => {
                      setServiceT007({
                        ...serviceT007,
                        DescriptionOfObstaclesDimensions: e.target.value,
                      })
                    }}
                    disabled={Submitted}
                  />
                </div>
              </div>

              <div className='gap-1 justify-content-xl-between d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row flex-1 my-5'>
                <div style={{flex: 0.4}} className='mb-5 mb-sm-5 mb-md-5 mb-lg-5'>
                  <label className='fs-4 text-gray-700 me-2 '>
                    {intl.formatMessage({id: 'DIMENSIONS_OF_THE_SERVING'})}
                  </label>
                </div>
                <div
                  style={{flex: 0.6}}
                  className='gap-2 justify-content-xl-between justify-content-lg-between  d-xl-flex d-lg-flex flex-md-column flex-sm-column flex-column flex-xl-row flex-lg-row'
                >
                  <div className='d-flex mb-3 mb-sm-4'>
                    <label className='fs-6 text-gray-700 me-2 '>
                      {intl.formatMessage({id: 'WIDTH'})}
                    </label>
                    <label className='fs-6 text-gray-700 me-4'>(m)</label>
                    <input
                      type='number'
                      className='form-control form-control-solid w-100px'
                      placeholder={intl.formatMessage({id: 'NUMBER'})}
                      value={serviceT007?.ServingsWidth || ''}
                      onChange={(e) => {
                        setServiceT007({...serviceT007, ServingsWidth: e.target.value})
                      }}
                      disabled={Submitted}
                    />
                  </div>
                  <div className='d-flex mb-3 mb-sm-4 pe-14'>
                    <label className='fs-6 text-gray-700 me-2 '>
                      {intl.formatMessage({id: 'HEIGHT'})}
                    </label>
                    <label className='fs-6 text-gray-700 me-3'>(m)</label>
                    <input
                      type='number'
                      className='form-control form-control-solid w-100px'
                      placeholder={intl.formatMessage({id: 'NUMBER'})}
                      value={serviceT007?.ServingsHeight ?? ''}
                      onChange={(e) => {
                        setServiceT007({...serviceT007, ServingsHeight: e.target.value})
                      }}
                      disabled={Submitted}
                    />
                  </div>
                </div>
              </div>
              */}
              <div className='gap-1 justify-content-xl-between d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row flex-1 my-5'>
                <div style={{flex: 0.5}} className='mb-5 mb-sm-5 mb-md-5 mb-lg-5'>
                  <label className='fs-4 text-gray-700 me-2 '>
                    {intl.formatMessage({id: 'FRONT_ANGLE'})}
                  </label>
                </div>
                <div
                  style={{flex: 0.5, marginLeft: 17}}
                  className='gap-5 justify-content-xl-between justify-content-lg-between  d-xl-flex d-lg-flex flex-md-column flex-sm-column flex-column flex-xl-row flex-lg-row'
                >
                  <div className='d-flex mb-3 mb-sm-4'>
                    <input
                      type='number'
                      className='form-control form-control-solid w-100px'
                      placeholder={intl.formatMessage({id: 'NUMBER'})}
                      value={serviceT007?.DistanceBetweenServingsAndFacadeAngle ?? ''}
                      onChange={(e) => {
                        setServiceT007({
                          ...serviceT007,
                          DistanceBetweenServingsAndFacadeAngle: e.target.value,
                        })
                      }}
                      disabled={Submitted}
                    />
                  </div>
                </div>
              </div>

              {!Submitted && (
                <div className='d-flex gap-5 justify-content-end my-5'>
                  <span style={{cursor: isDisabled ? 'not-allowed' : 'pointer'}}>
                    <Button
                      className='btn btn-dark'
                      disabled={isDisabled}
                      onClick={async () => {
                        if (!lodash.isEqual(serviceT007, t1init)) {
                          setShowCancel(true)
                        } else {
                          if (inputChange) {
                            setServiceT007({...t1init})
                            setObstacleSolSelect(null)
                            setObstacleHauterSelect(null)

                            await loadServiceT007()
                            setInputChange(false)
                          }
                        }
                      }}
                    >
                      {intl.formatMessage({id: 'RESET'})}
                      <i className='fa-solid fa-eraser fs-4 ms-2'></i>
                    </Button>
                  </span>
                  <span style={{cursor: isDisabled ? 'not-allowed' : 'pointer'}}>
                    <Button
                      type='button'
                      className='btn btn-danger'
                      onClick={handleClickT007}
                      disabled={isDisabled}
                    >
                      {intl.formatMessage({id: 'SAVE'})}
                      <i className='fa-regular fa-floppy-disk fs-4 ms-2'></i>
                    </Button>
                  </span>
                </div>
              )}
            </div>
          </form>
          <Modal show={showCancel} centered>
            <div className='text-center p-5 w-100' data-bs-theme={mode}>
              <div
                className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
                data-bs-theme={mode}
              >
                <div className='d-flex align-items-center justify-content-between'>
                  <div className='fw-bolder text-gray-700 py-3'>
                    {intl.formatMessage({id: 'INFORMATION'})}
                  </div>
                  <div className='p-1 cursor-pointer' onClick={onCancelReset}>
                    <i className='fa fa-close text-danger'></i>
                  </div>
                </div>
                <div className={'text-start py-3'}>
                  <div>{intl.formatMessage({id: 'RESET_CONFIRM_MESSAGE'})}</div>
                </div>
                <div className='d-flex align-items-center justify-content-evenly'>
                  <button className={'btn btn-secondary'} onClick={onCancelReset}>
                    {intl.formatMessage({id: 'NO'})}
                  </button>
                  {!loading && (
                    <button className={'btn btn-primary'} onClick={onConfirmCancel}>
                      {intl.formatMessage({id: 'YES'})}
                    </button>
                  )}
                  {loading && (
                    <button className={'btn btn-primary'} onClick={() => {}}>
                      {'...'}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </div>
  )
}

export default ToggleButtonform7
